module.exports = __webpack_public_path__ + "img/cooperate_22.723b0802.png";